export const AVAILABLE_FREQUENCY_STATUS = new Map([
	[1, {
		"id": 1,
		"name": "P",
		"description": "Presente"
	}],
	[2, {
		"id": 2,
		"name": "F",
		"description": "Faltou"
	}]
]);